import React, { useRef, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import useOnClickOutside from 'use-onclickoutside'
import { IoClose } from "react-icons/io5";



const CustomFilterSelect = ({ label_text, options, state, setState, isDisabled, isMulti, clearable, error, placeholder }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [inputValue, setInputValue] = useState("");

    const inputRef = useRef(null);

    useOnClickOutside(inputRef, () => setIsOpen(false));

    const handleOpenDropdown = () => {
        setIsOpen(!isOpen)
    }

    return (
        <div>
            <span className="text-xs  block text-gray-500">
                {label_text}
            </span>
            <div
                ref={inputRef}
                onClick={handleOpenDropdown}
                className={`
                        relative rounded-md text-[12px] bg-white
                        ${isDisabled ? "border border-[#e4e4e4]" :
                        isFocused ? "border border-[#4c0788] shadow-[0_0_6px_#242656]" :
                            state ? "border border-[#4c0788]" :
                                error ? "border border-[#ef4444]" :
                                    "border border-[#cbd5e1]"
                    }
                `}
            >
                <div className="h-[36.8px]">
                    <input
                        type="text"
                        disabled={isDisabled}
                        value={inputValue}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        onChange={(e) => setInputValue(e.target.value)}
                        className={`w-full px-3 py-2 text-[12px] bg-transparent outline-none cursor-default ${state?.length > 0 ? "placeholder:text-primary" : "placeholder:text-gray-500" }`}
                        placeholder={state?.length > 0
                            ? `${state?.length} ${state?.length > 1 ? "jobs" : "job"} selected`
                            : placeholder}
                    />
                    <div className="absolute right-0 top-0">
                        <div className="flex flex-row">
                            {
                                state?.length > 0 && clearable && !isDisabled && (
                                    <div
                                        className="h-full px-2 my-auto cursor-pointer text-primary hover:text-gray-600"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setState([]);
                                        }}
                                    >
                                        <IoClose className="min-h-[20px] min-w-[20px] my-auto" />
                                    </div>
                                )
                            }
                            <div className="border-r-[0.9px] border-gray-300 h-[21px] my-auto bg-blue-100"></div>
                            <div>
                                <FaChevronDown className="pointer-events-none h-[20px] text-[12px] mx-[13px] m-[8px]" />
                            </div>
                        </div>
                    </div>
                </div>


                {/* Dropdown */}
                {isOpen && (
                    <div className="absolute top-[45px] z-10 w-full bg-white border border-[#cbd5e1] max-h-[300px] overflow-y-auto py-1 rounded-md">
                        {options
                            .filter(option =>
                                option.label.toLowerCase().includes(inputValue.toLowerCase())
                            )
                            .map((option, index) => (
                                <div
                                    key={index}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setState(
                                            state?.some(o => o.value === option.value)
                                            ? state.filter(o => o.value !== option.value)
                                            : [...(state || []), option]
                                        );
                                        setInputValue("");
                                        inputRef.current?.querySelector("input")?.focus();
                                    }}
                                    className={`flex items-center gap-2 px-3 py-2 text-[12px] cursor-pointer text-[#500]`}
                                >
                                    <input
                                        type="checkbox"
                                        checked={state?.some(o => o.value === option.value)}
                                        readOnly
                                        className="pointer-events-none accent-[#242656] min-h-[16px] min-w-[16px]"
                                    />
                                    <span>{option.label}</span>
                                </div>
                            ))}
                    </div>
                )}
            </div>
        </div>
    )
}

export default CustomFilterSelect;